export default __webpack_public_path__ + "static/media/shenhe.debe1eef.png";